import { useTheme } from "./ThemeProvider";
import "./shell.css";

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" className="theme-toggle-icon" aria-hidden>
      <circle cx="12" cy="12" r="4" fill="currentColor" />
      <path
        d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" className="theme-toggle-icon" aria-hidden>
      <path d="M16 3.5A8.5 8.5 0 1 0 20.5 14 7 7 0 0 1 16 3.5z" fill="currentColor" />
    </svg>
  );
}

export function ThemeToggle({ onChange, disabled = false }: { onChange?: (mode: "light" | "dark") => void; disabled?: boolean }) {
  const { mode, setMode } = useTheme();
  const next = mode === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      disabled={disabled}
      className="theme-toggle top-nav-chip"
      data-tour="theme-toggle"
      onClick={() => (onChange ? onChange(next) : setMode(next))}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
    >
      {mode === "dark" ? <SunIcon /> : <MoonIcon />}
      <span className="theme-toggle-label">{mode === "dark" ? "Light" : "Dark"}</span>
    </button>
  );
}
